export default "<div class=\"login container-fluid background-login center-content card-content p-0\">\r\n  <div class=\"overlay\">\r\n  </div>\r\n</div>";